/* DillySocks — Cart analytics bridge (fallback for GTM / web pixels).

   Shopify Customer Events (product_added_to_cart / product_removed_from_cart)
   normally come from shop_events_listener intercepting /cart/add|/cart/change.
   That path silently drops events when a Cart Transform merges lines, and
   some custom ATC flows are easy to miss in Tag Manager debugging.

   Themes cannot re-publish STANDARD pixel events (Shopify blocks that).
   This script publishes CUSTOM events that a Custom Pixel can subscribe to
   and forward into dataLayer / GA4:

     ds:product_added_to_cart
     ds:product_removed_from_cart

   Wire them in Settings → Customer events → your GTM pixel, e.g.:

     analytics.subscribe('ds:product_added_to_cart', (event) => {
       window.dataLayer = window.dataLayer || [];
       window.dataLayer.push({
         event: 'product_added_to_cart',
         ...event.customData,
       });
     });
     analytics.subscribe('ds:product_removed_from_cart', (event) => {
       window.dataLayer = window.dataLayer || [];
       window.dataLayer.push({
         event: 'remove_from_cart',
         ...event.customData,
       });
     });

   View events (view_item / view_item_list) must come from Shopify's
   product_viewed / collection_viewed — subscribe to those in the same pixel
   and map to GA4 names. They are not emitted from this file. */

import { StandardEvents } from '@shopify/events';

(function () {
  'use strict';

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (err) {
      /* Pixel sandbox / privacy — never break cart UX */
    }
  }

  function linePayload(line, cart) {
    if (!line) return { cart_total_quantity: cart && cart.totalQuantity };
    var merch = line.merchandise || {};
    var product = merch.product || {};
    var price = (merch.price && merch.price.amount) || (line.cost && line.cost.totalAmount && line.cost.totalAmount.amount);
    var currency =
      (merch.price && merch.price.currencyCode) ||
      (line.cost && line.cost.totalAmount && line.cost.totalAmount.currencyCode);
    return {
      product_id: product.id || merch.productId || null,
      product_title: product.title || merch.title || null,
      variant_id: merch.id || null,
      variant_title: merch.title || null,
      quantity: line.quantity || 1,
      price: price || null,
      currency: currency || null,
      cart_total_quantity: cart && cart.totalQuantity,
    };
  }

  document.addEventListener(StandardEvents.cartLinesUpdate, function (event) {
    /* CartLinesUpdateEvent puts fields on the event itself (not event.detail). */
    var action = event && event.action;
    var promise = event && event.promise;
    var lines = (event && event.lines) || [];
    if (!promise || (action !== 'add' && action !== 'remove')) return;

    promise
      .then(function (result) {
        if (!result || (result.detail && result.detail.didError)) return;
        var cart = result.cart;
        var name = action === 'add' ? 'ds:product_added_to_cart' : 'ds:product_removed_from_cart';

        if (cart && Array.isArray(cart.lines) && cart.lines.length && lines.length) {
          lines.forEach(function (reqLine) {
            var match =
              cart.lines.find(function (l) {
                var mid = l.merchandise && (l.merchandise.id || l.merchandise.legacyResourceId);
                return String(mid) === String(reqLine.merchandiseId) || String(l.id) === String(reqLine.id);
              }) || cart.lines[cart.lines.length - 1];
            publish(name, linePayload(match, cart));
          });
        } else {
          publish(name, {
            quantity: lines[0] && lines[0].quantity,
            variant_id: lines[0] && (lines[0].merchandiseId || lines[0].id),
            cart_total_quantity: cart && cart.totalQuantity,
          });
        }
      })
      .catch(function () {
        /* ignore rejected cart updates */
      });
  });
})();
